const initialState = {
  dataLoggerDevices: JSON.parse(localStorage.getItem('redux_sync_DataLoggerDevices')) || [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  let payloadData

  switch (action.type) {
    case "DATA_LOGGER_DEVICES_FETCH_PENDING":
    case "CHILD_COMPANY_AND_UNALLOCATED_DATA_LOGGER_DEVICES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case "DATA_LOGGER_DEVICES_FETCH_REJECTED":
    case "CHILD_COMPANY_AND_UNALLOCATED_DATA_LOGGER_DEVICES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "DATA_LOGGER_DEVICES_FETCH_FULFILLED":
    case "CHILD_COMPANY_AND_UNALLOCATED_DATA_LOGGER_DEVICES_FETCH_FULFILLED":
      payloadData = action.payload.data
      localStorage.setItem('redux_sync_DataLoggerDevices',JSON.stringify(payloadData))
      return {
        ...state,
        fetching: false,
        fetched: true,
        dataLoggerDevices: payloadData,
        errors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      localStorage.removeItem('redux_sync_DataLoggerDevices')
      return {
        ...initialState,
        dataLoggerDevices: [],
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState,
        dataLoggerDevices: [],
      }
    default:
      return state
  }


}



// WEBPACK FOOTER //
// ./src/reducers/dataLoggerDevicesReducer.js